import cn from 'classnames';
import { cloneElement } from 'react';
import { Link } from '#components/atoms/link/Link.tsx';
import { Tooltip } from '#components/atoms/tooltip/Tooltip.tsx';
import styles from './InlineIconLink.module.css';

type Props = {
  className?: string;
  title: React.ReactNode;
  children: React.ReactElement<React.ComponentProps<'svg'> & { title?: string }>;
} & React.ComponentPropsWithoutRef<typeof Link>;

export function InlineIconLink({ className, title, children, ...linkProps }: Props) {
  const svgChild = cloneElement(children, { 'aria-hidden': true });

  return (
    <Tooltip content={title} className={cn(className, styles.InlineIconLink_link)} render={<Link {...linkProps} />}>
      {svgChild}
      <span className="visually-hidden">{title}</span>
    </Tooltip>
  );
}
